/* eslint-disable tailwindcss/no-arbitrary-value */
import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import { RichText } from '@hyphengroup/cms-components/components/RichText';
import React from 'react';
import { ComponentLicensedAndGroup } from '$/(cms)/_modules/cmsService/types';

export const AboutModule: React.FC<ComponentLicensedAndGroup> = ({ items }) => {
  return (
    <div className="py-spacing/padding/y">
      <div className="mx-auto max-w-[1536px] px-4 sm:px-6 md:px-8 lg:px-10">
        <div className="grid grid-cols-2 gap-spacing/gap/y">
          {items?.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className="flex flex-col gap-spacing/gap/y">
              <h3 className="font-bold text-text/primary text-font-size/xl leading-line-height/xl md:text-font-size/2xl md:leading-[30px] lg:text-font-size/3xl lg:leading-[34px]">
                {item.title}
              </h3>
              {item?.image?.url && (
                <CmsImage
                  unoptimized
                  src={item.image?.url}
                  alt={item.image?.alternativeText}
                  width={500}
                  height={56}
                  className="h-full max-h-7 w-fit object-contain sm:max-h-10 md:max-h-14"
                />
              )}
              <RichText className="font-medium text-text/secondary-lighter text-sm leading-5 sm:text-base sm:leading-[22px] md:text-lg md:leading-6">
                {item.description}
              </RichText>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
